export function downloadFile(data: string, filename: string, ext: string = 'json') {
  const blob = new Blob([data]);
  const fileDownloadUrl = URL.createObjectURL(blob);
  const element = document.createElement('a');

  element.href = fileDownloadUrl;
  element.download = `${filename}-export.${ext}`;
  element.click();
  element.parentNode?.removeChild(element);
}
